(ns ui.editor2.sidebar-location
  (:require [clojure.string :as str]
            [storrito.editor.sticker-design :as sticker-design]
            [ui.editor2.common :as common]))

(defn location-edit-sidebar
  [state]
  [:div
   {:class ["flex" "flex-col" "gap-2" "w-full"]}

   (common/invisible-design-section
     {:design sticker-design/invisible-location-design
      :text "INVISIBLE"})

   [:div
    {:class ["flex" "items-center" "justify-between" "w-full"]}
    [:span
     {:class ["text-xs" "font-medium"]}
     "Designs"]]

   [:ul.grid.grid-cols-1.gap-6.lg:grid-cols-1
    (map
      (fn [design]
        (let [text-props (:text-props design)]
          [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200
           {:style {:background-color (or (:bg-color design)
                                          "#ffffff")}}
           [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
            {:type "button"
             :on {:click [[:editor2/set-asset-design design]
                          [:editor2/prepare-assets!]]}}
            [:img.mr-2
             {:style {:width "22px"
                      :height "22px"}
              :src (get-in design
                           [:icon-props :src])}]
            [:span
             {:style (merge {:fontSize "30px"
                             :fontFamily (:fontFamily text-props
                                           "AvenyT")
                             :color (:fill text-props)
                             :opacity (:opacity design)}
                            (when (:gradient design)
                              (let [color-string (str/join "," (vals (:gradient design)))]
                                {:-webkit-background-clip "text"
                                 :-webkit-text-fill-color "transparent"
                                 :background-image (str "linear-gradient(90deg, " color-string ")")})))}
             "LOCATION"]]]))
      sticker-design/new-location-designs)
    ]])
